import { render, staticRenderFns } from "./MovimientosDistribuidor.vue?vue&type=template&id=00610738"
import script from "./MovimientosDistribuidor.vue?vue&type=script&lang=js"
export * from "./MovimientosDistribuidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports